<script lang="ts">
	import GoogleTagManager from '$lib/components/GoogleTagManager.svelte';
	import { PUBLIC_POSTHOG_API_KEY } from '$env/static/public';
	import posthog from 'posthog-js';
	import { browser } from '$app/environment';
	import { PUBLIC_ENVIRONMENT } from '$env/static/public';
	import { onMount } from 'svelte';

	// non blocking, load on client side only
	onMount(() => {
		// if (browser) {
		// 	const hsFormScript = document.createElement('script');
		// 	hsFormScript.type = 'text/javascript';
		// 	hsFormScript.charset = 'utf-8';
		// 	hsFormScript.src = '//js.hsforms.net/forms/embed/v2.js';
		// 	hsFormScript.onload = () => {
		// 		console.log('loaded');
		// 	};
		// 	document.head.appendChild(hsFormScript);
		// }
		if (browser && PUBLIC_ENVIRONMENT === 'production') {
			posthog.init(PUBLIC_POSTHOG_API_KEY, {
				api_host: 'https://us.i.posthog.com',
				person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
				persistence: 'cookie' // this works across subdomains
			});

			const hsScript = document.createElement('script');
			hsScript.type = 'text/javascript';
			hsScript.id = 'hs-script-loader';
			hsScript.src = '//js.hs-scripts.com/24311136.js';
			document.head.appendChild(hsScript);

			// https://stackoverflow.com/questions/6432984/how-to-add-a-script-element-to-the-dom-and-execute-its-code
			const fprCode = `(function (w) {
				w.fpr =
					w.fpr ||
					function () {
						w.fpr.q = w.fpr.q || [];
						w.fpr.q[arguments[0] == 'set' ? 'unshift' : 'push'](arguments);
					};
			})(window);
			fpr('init', { cid: 'naedwk7i' });
			fpr('click');`;
			const fprScript = document.createElement('script');
			fprScript.type = 'text/javascript';
			try {
				fprScript.appendChild(document.createTextNode(fprCode));
				document.head.appendChild(fprScript);
			} catch {
				fprScript.text = fprCode;
				document.head.appendChild(fprScript);
			}

			const fprJs = document.createElement('script');
			fprJs.type = 'text/javascript';
			fprJs.src = 'https://cdn.firstpromoter.com/fpr.js';

			const rb2bCode = `!(function () {
				var reb2b = (window.reb2b = window.reb2b || []);
				if (reb2b.invoked) return;
				reb2b.invoked = true;
				reb2b.methods = ['identify', 'collect'];
				reb2b.factory = function (method) {
					return function () {
						var args = Array.prototype.slice.call(arguments);
						args.unshift(method);
						reb2b.push(args);
						return reb2b;
					};
				};
				for (var i = 0; i < reb2b.methods.length; i++) {
					var key = reb2b.methods[i];
					reb2b[key] = reb2b.factory(key);
				}
				reb2b.load = function (key) {
					var script = document.createElement('script');
					script.type = 'text/javascript';
					script.async = true;
					script.src = 'https://s3-us-west-2.amazonaws.com/b2bjsstore/b/' + key + '/reb2b.js.gz';
					var first = document.getElementsByTagName('script')[0];
					first.parentNode.insertBefore(script, first);
				};
				reb2b.SNIPPET_VERSION = '1.0.1';
				reb2b.load('VN080H4WKJ6J');
			})();`;
			const rb2bScript = document.createElement('script');
			rb2bScript.type = 'text/javascript';
			try {
				rb2bScript.appendChild(document.createTextNode(rb2bCode));
				document.head.appendChild(rb2bScript);
			} catch {
				rb2bScript.text = rb2bCode;
				document.head.appendChild(rb2bScript);
			}

			const linkedInCode = `_linkedin_partner_id = '6198852';
			window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
			window._linkedin_data_partner_ids.push(_linkedin_partner_id);`;
			const linkedInScript = document.createElement('script');
			linkedInScript.type = 'text/javascript';
			try {
				linkedInScript.appendChild(document.createTextNode(linkedInCode));
				document.head.appendChild(linkedInScript);
			} catch {
				linkedInScript.text = linkedInCode;
				document.head.appendChild(linkedInScript);
			}

			const linkedInTrackingCode = `
			(function (l) {
				if (!l) {
					window.lintrk = function (a, b) {
						window.lintrk.q.push([a, b]);
					};
					window.lintrk.q = [];
				}
				var s = document.getElementsByTagName('script')[0];
				var b = document.createElement('script');
				b.type = 'text/javascript';
				b.async = true;
				b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
				s.parentNode.insertBefore(b, s);
			})(window.lintrk);
		`;
			const linkedInTrackingScript = document.createElement('script');
			linkedInTrackingScript.type = 'text/javascript';
			try {
				linkedInTrackingScript.appendChild(document.createTextNode(linkedInTrackingCode));
				document.head.appendChild(linkedInTrackingScript);
			} catch {
				linkedInTrackingScript.text = linkedInTrackingCode;
				document.head.appendChild(linkedInTrackingScript);
			}
		}
	});
</script>

{#if PUBLIC_ENVIRONMENT === 'production'}
	<GoogleTagManager />
{/if}

<svelte:head>
	{#if PUBLIC_ENVIRONMENT === 'production'}
		<!-- linkedin -->
		<noscript>
			<img
				height="1"
				width="1"
				style="display:none;"
				alt=""
				src="https://px.ads.linkedin.com/collect/?pid=6198852&fmt=gif"
			/>
		</noscript>
	{/if}
</svelte:head>
